/* sugar:assets/media-video-lazy.js@2.0.0 */
/* Media blocks below the first screen render their muted autoplay video with
   every file address parked in a data- attribute (sources, poster, fallback
   image), so the page downloads nothing for it on load. This attaches the files
   and starts playback when the video comes within 300px of the viewport.
   `_lazyRestore` is the same hook the inline first-screen script sets, which
   Tabs and Variable Media call when they reveal a panel. */
(function () {
  if (window.SugarMediaVideoLazy) return;

  function restore(v) {
    if (v._mdLoaded) return;
    v._mdLoaded = true;
    var poster = v.getAttribute('data-poster');
    if (poster) {
      v.setAttribute('poster', poster);
      v.removeAttribute('data-poster');
    }
    var sources = v.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) {
      sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
      sources[i].removeAttribute('data-src');
    }
    v.load();
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          var v = entries[i].target;
          io.unobserve(v);
          restore(v);
          if (v.autoplay) v.play().catch(function () {});
        }
      }, { rootMargin: '300px 0px' })
    : null;

  function scan(root) {
    var list = (root || document).querySelectorAll('video[data-md-lazy]');
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (v._mdSeen) continue;
      v._mdSeen = true;
      v._lazyRestore = restore.bind(null, v);
      if (io) io.observe(v);
      else v._lazyRestore();
    }
  }

  window.SugarMediaVideoLazy = { scan: scan };
  scan(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
